var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5204 7.75395L14 14.3897L23.4796 7.75395C23.361 7.04569 22.7401 6.5 22 6.5H6C5.25987 6.5 4.63896 7.04569 4.5204 7.75395ZM23.5 8.96033L14.2867 15.4096C14.1146 15.5301 13.8854 15.5301 13.7133 15.4096L4.5 8.96033V20C4.5 20.8239 5.17614 21.5 6 21.5H22C22.8239 21.5 23.5 20.8239 23.5 20V8.96033ZM3.5 8C3.5 6.62386 4.62386 5.5 6 5.5H22C23.3761 5.5 24.5 6.62386 24.5 8V20C24.5 21.3761 23.3761 22.5 22 22.5H6C4.62386 22.5 3.5 21.3761 3.5 20V8Z",
    fill: "#121212"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail.0f216ac2.svg";
export { ForwardRef as ReactComponent };